import {AbstractControl, ValidatorFn} from '@angular/forms';

import {LatinDigitsValidatorKey} from './custom-validator-keys';

export function LatinDigitsValidator(includeWhitespace = true): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const controlValue = control.value;

        if (!controlValue) {
            return null;
        }

        const regex = !includeWhitespace ? new RegExp(/^[a-zA-Z0-9]+$/) : new RegExp(/^[a-zA-Z0-9\s]+$/);

        return !regex.test(controlValue) ? {[LatinDigitsValidatorKey]: true} : null;
    };
}
